const getActiveCall = () => {
    try {
        if (window.localStorage.getItem('__ks-active-call')) {
            return JSON.parse(window.localStorage.getItem('__ks-active-call'));
        }
        throw 'not exist active call';
    } catch (err) {
        return {}
    }
}

const globalData = {
    state: {
        loading: false,
        activeCall: getActiveCall(),
        active_call_changed: 0,
        openDateTimePickerId: null,
        l_search_string: '',
        facets: [
            {
                'data_mode_name': null,
                'facet_name': null,
                'facet_count': null,
            }
        ],
        showViews: false,
        showFields: false,
        qaAble: false,
        smsTaskData: null,
        selectedFacility:     {'id': null}
    },

    getters: {
        loading: (state) => state.loading,
        activeCall: (state) => state.activeCall,
        active_call_changed: (state) => {
            return () => {
                return state.active_call_changed
            };
        },
        openDateTimePickerId: (state) => state.openDateTimePickerId,
        l_search_string: (state) => state.l_search_string,
        facets: (state) => state.facets,
        showViews: (state) => state.showViews,
        showFields: (state) => state.showFields,
        qaAble: (state) => state.qaAble,
        smsTaskData: (state) => state.smsTaskData,
        selectedFacility: (state) => state.selectedFacility
    },
    actions: {},
    mutations: {
        setLoading: (state, payload) => (state.loading = payload),
        setActiveCall: (state, payload) => (state.activeCall = payload),
        setActiveCallChanged(state, index) {
            state.active_call_changed = index;
        },
        setOpenDateTimePickerId(state, payload) {
            state.openDateTimePickerId = payload;
        },
        setLocalSearchString: (state, payload) => (state.l_search_string = payload),
        setFacets: (state, payload) => {
            state.facets = payload;
        },
        setShowViews: (state, payload) => (state.showViews = payload),
        setShowFields: (state, payload) => (state.showFields = payload),
        setQaAble: (state, payload) => (state.qaAble = payload),
        setSmsTaskData(state, payload) {
            state.smsTaskData = payload
        },
        setSelectedFacility: (state, payload) => (state.selectedFacility = payload)

    }
}

export default globalData;
